export default __webpack_public_path__ + "./images/rw.d574406d.png";